import { useTranslation } from "react-i18next";
import Header from "~/components/header/Header";
import Footer from "~/components/home/Footer";
import { AllFeaturesHero } from "~/components/products/all-features/AllFeaturesHero";
import { AllFeaturesBody } from "~/components/products/all-features/AllFeaturesBody";
import { ShopFeaturesBanner } from "~/components/products/all-features/ShopFeaturesBanner";
import { DRIVE_ALL_FEATURES } from "~/data/products/drive";

export const handle = { sitemap: { title: "Bouncie Drive — All Features" } };

export default function ProductsDriveFeatures() {
  const { t } = useTranslation("products");
  const content = DRIVE_ALL_FEATURES;

  return (
    <>
      <title>{t(content.metaTitle)}</title>
      <meta name="description" content={t(content.metaDescription)} />

      <Header variant="default" />
      <AllFeaturesHero headline={content.headline} description={content.description} />
      <AllFeaturesBody
        categories={content.categories}
        featureDetailsHeading={content.featureDetailsHeading}
        expandAllLabel={content.expandAllLabel}
        collapseAllLabel={content.collapseAllLabel}
      />
      <ShopFeaturesBanner content={content.banner} />
      <Footer />
    </>
  );
}
